<template>
  <v-idle
    id="idle"
    class="hide"
    :duration="600"
    @idle="onidle"
  />
  <nav
    ref="headerRef"
    class="navbar bg-structure fixed-top p-1"
  >
    <div class="container-fluid">
      <div class="dropdown d-flex align-items-center">
        <button
          class="btn text-white fs-5 border-0"
          @click="offcanvas.toggle"
        >
          <i class="fa fa-bars" />
        </button>
        <a class="navbar-brand text-white mx-1"> MatControl</a>
      </div>
      <form class="d-flex d-sm-flex">
        <span class="d-flex align-items-center navbar-text text-white p-0">
          Bienvenido,&nbsp; <b
            class="text-truncate d-inline-block me-2">
            {{ user?.NOMBRE_U }}
          </b>
          <button
            v-if="manual"
            type="button"
            class="btn btn-sm btn-outline-light mx-1"
            @click="openManual"
          >
            Ayuda <span class="manual-key">F1</span>
          </button>
          <button
            type="button"
            class="btn btn-sm bg-secondary-action mx-1"
            @click="logout"
          >
            <i class="fas fa-sign-out-alt"/>
            Salir
          </button>
        </span>
      </form>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import {useOffcanvasStore} from "@/stores/offcanvas.ts";
import {useAuthStore} from "@/stores/useAuthStore.ts";
import {useRouter} from "vue-router";
import { ROUTE_NAMES } from "@/shared/constants/routeNames.ts";
import WARNING_MESSAGES from '@/shared/constants/warningMessages.ts';
import { swalWarning } from '@/shared/utils/swalAlert.ts';
import { useUserManual } from '@/shared/composables/useUserManual.ts';

const offcanvas = useOffcanvasStore();
const authStore = useAuthStore();
const router = useRouter();
const user = computed(() => authStore.user?.user_data);
const { manual, open: openManual } = useUserManual();

const logout = async () => {
  offcanvas.close();
  authStore.logout();
  await router.replace({ name: ROUTE_NAMES.LOGIN.name });
};

const onidle = () => {
  swalWarning(WARNING_MESSAGES.SESSION_INVALID)
  logout();
};
</script>

<style scoped>
  .dropdown-menu li {
    margin-bottom: 0.5rem;
  }

  .hide {
    display: none !important;
  }

  .manual-key {
    display: inline-block;
    margin-left: 0.35rem;
    padding: 0 0.35rem;
    border: 1px solid rgba(255, 255, 255, 0.7);
    border-radius: 4px;
    font-size: 0.72rem;
    line-height: 1.4;
  }


  @media (min-width: 992px) {
    .navbar-text {
      text-align: center;
    }

    .navbar-text img {
      margin: 0 auto;

    }

    .navbar-text button {
      display: block;
      margin: 10px auto;
    }
  }

  @media (max-width: 992px) {
    .navbar-text {
      text-align: center;
      font-size: 0.65rem;
    }

    .navbar-brand {
      font-size: 1.1rem;
    }
  }
</style>